<script lang="ts">
  let { name, size = 20 }: { name: string; size?: number } = $props();
</script>

<svg
  viewBox="0 0 24 24"
  width={size}
  height={size}
  aria-hidden="true"
  fill="none"
  stroke="currentColor"
  stroke-width="1.8"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  {#if name === 'home'}
    <path d="m3 11 9-8 9 8" /><path d="M5 10v10h14V10M9 20v-6h6v6" />
  {:else if name === 'trend'}
    <path d="M4 18V5M4 18h16M7 14l4-4 3 2 5-6" />
  {:else if name === 'wallet'}
    <path d="M4 7.5A2.5 2.5 0 0 1 6.5 5H19v14H6.5A2.5 2.5 0 0 1 4 16.5z" /><path
      d="M4 8h15M15 12h6v4h-6a2 2 0 0 1 0-4Z"
    />
  {:else if name === 'arrow-down'}
    <path d="M12 4v15M6 13l6 6 6-6" />
  {:else if name === 'arrow-up'}
    <path d="M12 20V5M6 11l6-6 6 6" />
  {:else if name === 'list'}
    <path d="M9 6h11M9 12h11M9 18h11M4 6h.01M4 12h.01M4 18h.01" />
  {:else if name === 'filter'}
    <path d="M4 6h16M7 12h10M10 18h4" />
  {:else if name === 'moon'}
    <path d="M20 15.5A8 8 0 0 1 8.5 4 8 8 0 1 0 20 15.5Z" />
  {:else if name === 'sun'}
    <circle cx="12" cy="12" r="4" /><path
      d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"
    />
  {:else if name === 'close'}
    <path d="m6 6 12 12M18 6 6 18" />
  {:else if name === 'chevron-right'}
    <path d="m9 5 7 7-7 7" />
  {:else if name === 'chevron-left'}
    <path d="m15 5-7 7 7 7" />
  {:else if name === 'chevron-down'}
    <path d="m5 9 7 7 7-7" />
  {:else if name === 'calendar'}
    <rect x="3" y="5" width="18" height="16" rx="3" /><path d="M8 3v4M16 3v4M3 10h18" />
  {:else if name === 'download'}
    <path d="M12 3v12M7 10l5 5 5-5M5 20h14" />
  {:else if name === 'search'}
    <circle cx="11" cy="11" r="7" /><path d="m20 20-4-4" />
  {:else if name === 'more'}
    <circle cx="5" cy="12" r="1" fill="currentColor" stroke="none" /><circle
      cx="12"
      cy="12"
      r="1"
      fill="currentColor"
      stroke="none"
    /><circle cx="19" cy="12" r="1" fill="currentColor" stroke="none" />
  {:else}
    <circle cx="12" cy="12" r="9" /><path d="M12 8v4M12 16h.01" />
  {/if}
</svg>
